import type { PropsWithChildren } from "react";

import { Navigate } from "react-router-dom";

import { hasRequiredRole, useAuthStore } from "@/stores/auth-store";
import type { AdminRole } from "@/types/auth";

interface RoleGateProps extends PropsWithChildren {
  minRole: AdminRole;
}

export function RoleGate({ minRole, children }: RoleGateProps) {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRequiredRole(user.role, minRole, user.roles)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
